export default __webpack_public_path__ + "static/media/logo-secundario.ca475c93.png";